module.exports = __webpack_public_path__ + "static/media/_it.5ba963fa.svg";